import { useEffect, useState } from 'react';
import {
  useGetAllStatsStatusesQuery,
  useGetAllUsersLeadersOnStatsQuery,
} from '../../../../reduxToolkit/reducers/usersSlice';

type UseLeaderBoardDataParams = {
  tabId: string;
  courseId: number;
} | null;

export const useLeaderBoardData = (props: UseLeaderBoardDataParams) => {
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(20);
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');
  const [sortKey, setSortKey] = useState('totalBestScores');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [filters, setFilters] = useState<{
    tabId: number;
    passedExams: string;
    passedEqualityKey: string;
    passedExamsQty: string;
    score: string;
    scoreEqualityKey: string;
    scoreQty: string;
    statusFilter: number[];
  }>({
    tabId: Number(props?.tabId),
    passedExams: 'all',
    passedEqualityKey: 'equal',
    passedExamsQty: '0',
    score: 'allScores',
    scoreEqualityKey: 'equal',
    scoreQty: '0',
    statusFilter: [],
  });
  const baseParams = {
    page: page,
    perPage: perPage,
    sort: sort,
    sortKey: sortKey,
    search: debouncedSearch,
    courseId: props?.courseId,
  };
  const [applyFiltersCounter, setApplyFiltersCounter] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState<typeof filters | null>(null);
  // If user applied filters, include a snapshot of them in the query params.
  const statsParams = appliedFilters
    ? { ...baseParams, ...appliedFilters, _applied: applyFiltersCounter }
    : baseParams;

  const { data: usersLeadersOnStats } = useGetAllUsersLeadersOnStatsQuery(statsParams, {
    skip: !props || !props.courseId,
  });
  const { data: statsStatuses } = useGetAllStatsStatusesQuery({});

  useEffect(() => {
    console.log('props', props);
  }, [props]);
  return {
    statsStatuses,
    usersLeadersOnStats,
    page,
    setPage,
    perPage,
    setPerPage,
    sort,
    setSort,
    sortKey,
    setSortKey,
    search,
    setSearch,
    totalRows,
    setTotalRows,
    filters,
    setFilters,
    appliedFilters,
    setAppliedFilters,
    applyFiltersCounter,
    setApplyFiltersCounter,
    setDebouncedSearch,
  };
};
